import React, { useCallback, useEffect, useRef, useState } from 'react';

export default function SessionMenu({ user, logout }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return undefined;

    const onMouseDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        close();
      }
    };

    const onKeyDown = (e) => {
      if (e.key === 'Escape') close();
    };

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, close]);

  const displayName = user?.name?.split(' ')[0] || 'Atleta';

  return (
    <div ref={rootRef} className="relative text-right">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        className="inline-block rounded-md border border-iron-border bg-iron-surface px-3 py-1.5 font-mono text-[10px] text-iron-muted transition-colors hover:border-iron-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-iron-accent/70"
      >
        <span className="block text-[9px] uppercase tracking-wider">Sessão</span>
        <strong className="block text-sm text-iron-accent leading-tight">{displayName}</strong>
      </button>

      {open ? (
        <div
          role="menu"
          className="absolute right-0 top-full z-50 mt-1 min-w-[7rem] overflow-hidden rounded-md border border-iron-border bg-iron-surface shadow-lg"
        >
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              close();
              logout();
            }}
            className="w-full px-3 py-2 text-left font-mono text-[11px] text-iron-danger transition-colors hover:bg-iron-danger/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-iron-danger/50"
          >
            Sair
          </button>
        </div>
      ) : null}
    </div>
  );
}
